import { render } from "./FooterSction.vue?vue&type=template&id=4f1bbd7c&scoped=true"
import script from "./FooterSction.vue?vue&type=script&lang=js"
export * from "./FooterSction.vue?vue&type=script&lang=js"

import "./FooterSction.vue?vue&type=style&index=0&id=4f1bbd7c&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1bbd7c"]])

export default __exports__